// Community stats shown across the site (homepage proof block, /partners stat tiles).
// Update here as the community grows — every page reads from this file.
export const COMMUNITY_STATS = {
  couples: '3,500+',
  cities: '100+',
  followers: '100K+',
  growth: '3x',
} as const;
